import React, {Component} from 'react';
import Button from './../button/Button';
import Input from './../input/Input';
import Gallery from './../gallery/Gallery'
import ReactSVG from 'react-svg';
import ProgressiveImage from 'react-progressive-image';

import styles from './TitleBar.module.css';

import BackArrow from './../../assets/img/back-icon.svg';
import BackArrowBlack from './../../assets/img/back-icon-black.svg';
import ShareIcon from './../../assets/img/share.svg';

class TitleBar extends Component {

    constructor(props){
        super(props);
        this.offsetTop = 0;
        this.galleryRef = React.createRef();
        this.inputRef = React.createRef();
        this.state = {
            topBar: "hidden",
            searchInput: "hidden"
        };

        this.showSearch = this.showSearch.bind(this);
        this.renderImage = this.renderImage.bind(this);
        this.renderBack = this.renderBack.bind(this);
        this.renderSearch = this.renderSearch.bind(this);
        this.renderTopBar = this.renderTopBar.bind(this);
    }

    componentDidMount(props){
        let title = document.getElementById("title");
        this.offsetTop = title.parentElement.offsetTop - title.offsetTop;
        if(this.props.images){
            this.offsetTop = 450;
        }

        window.onscroll = function(){
            this.showHide(window.pageYOffset);
        }.bind(this);
    }

    showHide(pageYOffset){
        if(pageYOffset >= this.offsetTop && this.state.topBar !== "open"){
            this.setState({
                topBar: "open"
            });
        }
        if(pageYOffset < this.offsetTop && this.state.topBar === "open"){
            this.setState({
                topBar: "close"
            });
        }
    }

    resetGallery(){
        if(this.galleryRef.current){
            this.galleryRef.current.resetSlider();
        }
    }

    showSearch(){
        let searchInput;
        if(this.state.searchInput === "hide" || this.state.searchInput === "hidden"){
            searchInput = "show";
            setTimeout(function(){
                this.inputRef.current.focus();
            }.bind(this), 300);
        } else {
            searchInput = "hide";
        }
        this.setState({
            searchInput: searchInput
        });
    }

    renderTopBar() {
        let animation, className = "";
        if(this.state.topBar === "open"){
            animation = "animated slideInDown";
        }
        if(this.state.topBar === "close"){
            animation = "animated slideOutUp";
        }
        if(this.state.topBar === "hidden"){
            animation = styles.topBarHidden;
        }
        if(this.props.onSearch){
            className = styles.topBarWithSearch;
        }
        return (
            <div className={[styles.topBar, animation, className].join(' ')}>
                <h1>{this.props.title}</h1>
            </div>
        );
    }

    renderSearchInput() {
        let animation = "";
        if(this.state.searchInput === "show") {
            animation = "animated slideInDown";
        }
        if(this.state.searchInput === "hide") {
            animation = "animated slideOutUp";
        }
        if(this.state.searchInput !== "hidden") {
            return (
                <div className={[styles.searchInput, animation].join(' ')}>
                    <Input inputRef={this.inputRef} onChange={this.props.onSearch}/>
                </div>
            );
        }
    }

    renderImage() {
        if(this.props.images && this.props.images.length > 0){

            let fixedHeight;

            if(!this.props.adjustImage){
                fixedHeight = styles.imageContainer;
            }else{
                fixedHeight = styles.imageContainerAdjust;
            }

            let images = this.props.images.map((image, i) => {

                if(image === ""){
                    fixedHeight = styles.imageContainer;
                }

                image = typeof image == 'object' ? image.uri : image

                return (
                    <div className={[fixedHeight, this.props.className].join(' ')} key={i}>
                        <ProgressiveImage src={image} placeholder={image}>
                            {(src, loading) => <img src={src} alt="an image" style={{ opacity: loading ? 0 : 1 }} />}
                        </ProgressiveImage>
                    </div>
                );
            });

            return (
                <div className={styles.galleryContainer}>
                    <Gallery ref={this.galleryRef} images={images} adjustImage={this.props.adjustImage} className={fixedHeight}/>
                </div>
            );
        }
    }

    renderBack() {
        if(this.props.backTo){
            let back;
            if(this.state.topBar !== "open"){
                back = (
                    <ReactSVG onClick={this.props.backTo} src={BackArrowBlack} className={styles.backButton}/>
                );
            }else{
                back = (
                    <ReactSVG onClick={this.props.backTo} src={BackArrow} className={styles.backButton}/>
                );
            }
            return (
                <div className={styles.topBarBack}>
                    {back}
                </div>
            );
        }
    }

    renderSearch() {
        if(this.props.onSearch){
            return (
                <div className={styles.topBarSearch}>
                    <Button onClick={this.showSearch} className={styles.searchButton}>
                        Search
                    </Button>
                </div>
            );
        }
    }

    renderShareButton() {
        if(this.props.shareButton){
            return (
                // <Button styleType="rounded" >
                    <ReactSVG src={ShareIcon} className={styles.shareButton} onClick={this.props.shareButton}/>
                // </Button>
            );
        }
    }

    render() {
        let contentWithShare, imageClassName = "";
        if(this.props.images && this.props.images.length > 0){
            if(this.props.images.length === 1){
                imageClassName = styles.contentWithoutGallery;
            }else{
                imageClassName = styles.contentWithImage;
            }
        }
        if(this.props.shareButton){
            contentWithShare = styles.contentWithShare;
        }

        return (
            <div>
                {this.renderBack()}
                <div className={this.props.className} onAnimationEnd={this.props.onAnimationEnd}>
                    {this.renderSearch()}
                    {this.renderTopBar()}
                    {this.renderSearchInput()}
                    {this.renderImage()}
                    <div className={[styles.content, imageClassName, contentWithShare].join(' ')}>
                        {this.renderShareButton()}
                        <h2 id="title">{this.props.title}</h2>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }

}

export default TitleBar;